// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__16kFq","error":"Textarea_error__1uU3_","readonly":"Textarea_readonly__IGsDE","disabled":"Textarea_disabled__3nwPZ"};